import React from "react";
import {
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  Stack,
} from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import StarIcon from "@mui/icons-material/Star";
import BedIcon from "@mui/icons-material/Bed";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import PeopleIcon from "@mui/icons-material/People";

const AccommodationCard = ({ item }) => {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        mb: 3,
        p: 1,
        borderRadius: 3,
      }}
    >
      <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
        {item.images.map((img, i) => (
          <CardMedia
            key={i}
            component="img"
            image={img}
            alt={item.title}
            sx={{
              width: "33%",
              height: 100,
              borderRadius: 2,
              objectFit: "cover",
            }}
          />
        ))}
      </Box>
      <CardContent>
        <Typography fontWeight={600}>{item.title}</Typography>
        <Typography variant="body2" color="text.secondary">
          {item.desc}
        </Typography>
        <Typography variant="body2" mt={1}>
          {item.date}
        </Typography>

        <Stack direction="row" alignItems="center" gap={1} mt={1}>
          <FavoriteBorderIcon color="warning" />
          <Typography fontWeight={600} color="warning.main">
            ${item.price} /night
          </Typography>
        </Stack>

        <Stack direction="row" gap={3} mt={1} flexWrap="wrap">
          <Stack direction="row" alignItems="center" gap={0.5}>
            <BedIcon fontSize="small" color="disabled" />
            <Typography variant="caption">{item.beds} Beds</Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={0.5}>
            <PeopleIcon fontSize="small" color="disabled" />
            <Typography variant="caption">{item.sleeps} Sleeps</Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={0.5}>
            <SquareFootIcon fontSize="small" color="disabled" />
            <Typography variant="caption">{item.size} Sq Ft</Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={0.5}>
            <StarIcon sx={{ color: "#fbbf24" }} fontSize="small" />
            <Typography variant="caption">{item.rating}</Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default AccommodationCard;
